type EventConstructor<Data, Class, EventGroup> = (new (data: Data) => Class) & {
  key: EventGroup;
};

export default class EventManager<EventGroup> {
  private callbacks: Map<EventGroup, Function[]>;

  private getCallbacks(key: EventGroup) {
    const listeners = this.callbacks.get(key) ?? [];
    this.callbacks.set(key, listeners);
    return listeners;
  }

  constructor() {
    this.callbacks = new Map();
  }

  on<Data, Class>(
    eventType: EventConstructor<Data, Class, EventGroup>,
    callback: (data: Data) => void,
  ) {
    this.getCallbacks(eventType.key).push(callback);
  }

  off<Data, Class>(
    eventType: EventConstructor<Data, Class, EventGroup>,
    callback: (data: Data) => void,
  ) {
    const listeners = this.getCallbacks(eventType.key);
    const index = listeners.indexOf(callback);
    if (index !== -1) listeners.splice(index, 1);
  }

  send<Data, Class>(eventType: EventConstructor<Data, Class, EventGroup>, data: Data) {
    this.getCallbacks(eventType.key).forEach(callback => callback(data));
  }

  trigger<Class>(eventType: EventConstructor<undefined, Class, EventGroup>) {
    this.send(eventType, undefined);
  }

  // eslint-disable-next-line class-methods-use-this
  createEvent<T>(key: EventGroup) {
    return class {
      static key = key;

      data: T;

      constructor(d: T) {
        this.data = d;
      }
    };
  }
}
